import { render, staticRenderFns } from "./ModalTriggerList.vue?vue&type=template&id=82e0ff62&scoped=true"
import script from "./ModalTriggerList.vue?vue&type=script&lang=js"
export * from "./ModalTriggerList.vue?vue&type=script&lang=js"
import style0 from "./ModalTriggerList.vue?vue&type=style&index=0&id=82e0ff62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e0ff62",
  null
  
)

export default component.exports